var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeda(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "136px",
    height: "34px",
    viewBox: "0 0 136 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CD6B5FF1-A831-481E-A618-B9618243DC6B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.549869037 115.565382 0.549869037 115.565382 32.083203 0 32.083203"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0.485630622 0.294773797 26.464689 0.294773797 26.464689 14.8049526 0.485630622 14.8049526"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Landing_Page",
    transform: "translate(-138.000000, -100.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Upper_Nav"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigace",
    transform: "translate(0.000000, 64.761905)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Leda_Logo",
    transform: "translate(138.000000, 35.416667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 1.014881)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7279081,7.59248786 L101.833937,19.4063565 L93.4819751,19.4063565 L97.7279081,7.59248786 Z M92.6314871,0.549869037 L80.2216498,32.083203 L88.8566737,32.083203 L91.3111809,25.4039766 L103.909726,25.4039766 L106.223028,32.083203 L115.565382,32.083203 L103.154894,0.549869037 L92.6314871,0.549869037 Z M60.5432957,6.63850019 L63.8463388,6.63850019 C70.4062239,6.63850019 73.9448268,10.0917145 73.9448268,16.1345123 C73.9448268,22.3141552 70.4530756,25.7673696 64.3181091,25.7673696 L60.5432957,25.7673696 L60.5432957,6.63850019 Z M51.7657646,0.549869037 L51.7657646,32.083203 L62.1479656,32.083203 C67.9992191,32.083203 72.2933053,31.6746315 75.2189321,30.0390362 C80.4097072,27.1305838 82.911066,22.6330242 82.911066,16.1345122 C82.911066,10.1827264 80.4572096,5.68385723 75.6907024,2.77671432 C73.0481378,1.18564286 68.9434105,0.549869037 63.232712,0.549869037 L51.7657646,0.549869037 Z M25.293267,0.549869037 L25.293267,32.083203 L48.5577263,32.083203 L48.5577263,25.9945719 L34.0232957,25.9945719 L34.0232957,18.816417 L47.2361187,18.816417 L47.2361187,12.8181431 L34.0232957,12.8181431 L34.0232957,6.45713105 L48.0384536,6.45713105 L48.0384536,0.549869037 L25.293267,0.549869037 Z M-0.000130143541,0.549869037 L-0.000130143541,32.083203 L21.8958699,32.083203 L21.8958699,25.8583814 L8.72989856,25.8583814 L8.72989856,0.549869037 L-0.000130143541,0.549869037 Z",
    id: "Fill-1",
    fill: "#063479",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(109.320574, 0.360119)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9920804,14.3204286 L26.4648842,14.3204286 L26.4648842,10.367631 L20.8081952,10.367631 L26.1909321,4.40013096 L26.1909321,0.77929762 L15.4703579,0.77929762 L15.4703579,4.73144048 L20.5108172,4.73144048 L14.9920804,10.6734048 L14.9920804,14.3204286 Z M9.19874067,9.04108349 C9.08421435,10.3676311 8.44520957,11.0564407 7.32792727,11.0564407 C5.93669282,11.0564407 5.343889,9.93417874 5.343889,7.53709536 C5.343889,5.1655477 5.95946794,4.04328577 7.37347751,4.04328577 C8.49141053,4.04328577 9.06143923,4.65548817 9.15253971,5.93030962 L13.9658986,5.93030962 C13.8513722,2.53864289 11.3428555,0.294773797 7.39690335,0.294773797 C3.10802297,0.294773797 0.485630622,3.04870242 0.485630622,7.53709536 C0.485630622,11.9744169 3.10802297,14.8049526 7.44180287,14.8049526 C11.3428555,14.8049526 13.805822,12.5859645 14.0114488,9.04108349 L9.19874067,9.04108349 Z",
    id: "Fill-4",
    fill: "#063479",
    mask: "url(#mask-4)"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeda);
export default __webpack_public_path__ + "static/media/leda.6c17d7452e225f7f1432ccde231d58ba.svg";
export { ForwardRef as ReactComponent };